import React, { useContext } from 'react'
import { hostContext } from '../../context/hostContext';
import Evento from './eventos/Evento';

import style from '../../assets/styles/perfil-descargar.module.css'

const Eventos = () => {

    const { eventosAsistidos } = useContext(hostContext);

    return ( eventosAsistidos &&
        <div className={ style.eventosScreen } >
            <h2>Eventos Asistidos por {eventosAsistidos[0].nombre}</h2>
            <hr />
            {eventosAsistidos.map( ele => 
                <Evento key={ele._id} evento={ele} />
            )}
        </div>
    )

}

export default Eventos;
